import notify from "helpers/notify";
import post from "helpers/post";
import apiURL from "service/api-url";

const createContact = async (data) => {
    try {
        const res = await post(apiURL.contacts, {}, data);
        console.log(res);
        if (res.isSuccess) {
            notify('success', 'Your message created successfully')
            return true;
        }
        else {
            return false;
        }
    } catch (err) {
        notify('error', err.message);
        return false;
    }
};

export {
    createContact
};
